import store from '../store'
import { notificationActions } from '../actions/notificationActions'
import { spinnerActions } from '../actions/spinnerActions'

export const makeRequest = (request, onSuccess, onFailure, options = {}) => {
    const { dispatch } = store;
    const { checkEmptyResults = true } = options;

    dispatch(spinnerActions.show());

    request()
        .then(res => {
            if (checkEmptyResults && (!res.data || res.data.length === 0))
                dispatch(notificationActions.showError({ message: "No se han encontrado resultados" }));

            onSuccess(res)
        })
        .catch(err => {
            if (err.intercepted)
                return;

            if (onFailure)
                onFailure(err);
            else
                dispatch(notificationActions.showError({ message: err.message }));
        })
        .finally(() => dispatch(spinnerActions.hide()));
}